const DemoGels = {

  stm:[
    ["img1.jpeg"],
    ["img2.jpeg","img3.jpeg"]
  ],


  c:[
    ["inline_IP-UBA,IB-RIPK2.png", "inline_IP_UBA,IB_ubiquitin.png"]
  ],

  d:[
    ["inline_p-p65.png"],
    ["inline_p-IkBa.png"]
  ],
  e:[
    ["inline_RIPK2.png"],
    ["inline_p-p38.png","inline_NAGK.png","inline_beta-action.png"],
  ],

  i:[
    ["replicate_ip_uba,ib_rip2k.png","replicate_ip_uba,ib_ubi.png"]
  ],

  j:[
    ["replicate_p-p65.png"],
    ["replicate_nagk.png","replicate_p-IkBa.png"],
  ],

  k:[
    ["replicate_ripk2.png"],
    ["replicate_p-p38.png","replicate_beta-actin.png"]
  ],


  f1a_Ponceau:[
    ["is_f1a;Ponceau.png"]
  ],

  f1a_Vinculin:[
    ["is_f1a;Ponceau.png"]
  ],

  f1a_Morgana_CM:[
    ["is_f1a;Morgana_CM.png"]
  ],

  f1a_Morgana_TE:[
    ["is_f1a;Morgana_TE.png"]
  ],
  f1a_GAPDH:[
    ["is_f1a;GAPDH.png"]
  ],

  f1a_HSP90_CM:[
    ["is_f1a;HSP90_CM.png"]
  ],

  f1a_HSP90_TE:[
    ["is_f1a;HSP90_TE.png"]
  ],


  f1a_HSP70_CM:[
    ["is_f1a;HSP_70.png"]
  ],

  f1a_HSP70_TE:[
    ["is_f1a;HSP70_TE.png"]
  ],

  f1a_Vinculin_TE:[
    ["is_f1a;Vinculin_TE.png"]
  ]







}





export default DemoGels;

